import RightAngleTopLeft from "./svg/RightAngle_TopLeft.svg";
import RightAngleTopRight from "./svg/RightAngle_TopRight.svg";
import RightAngleBottomRight from "./svg/RightAngle_BottomRight.svg";
import RightAngleBottomLeft from "./svg/RightAngle_BottomLeft.svg";
import DoubleRightAngleLeft from "./svg/TwinRightAngleLeft.svg";
import DoubleRightAngleRight from "./svg/TwinRightAngleRight.svg";
import EqualUp from "./svg/Equilateral_Up.svg";
import EqualDown from "./svg/Equilateral_Down.svg";
import EqualLeft from "./svg/Equilateral_Left.svg";
import EqualRight from "./svg/Equilateral_Right.svg";
import Computer from "./svg/computer.svg";

export const SVGS = {
  RightAngleTopLeft,
  RightAngleBottomRight,
  DoubleRightAngleLeft,

  RightAngleTopRight,
  RightAngleBottomLeft,
  DoubleRightAngleRight,

  EqualUp,
  EqualDown,
  EqualLeft,
  EqualRight,
  Computer,
};
